<template>
  <InView :disable-effect="true" :threshold="1" @visible="handleVisible">
    <div>
      <svg
        viewBox="0 0 1240 656"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="monthly-premium-vs-age">
          <g id="lines">
            <g id="lines-2">
              <line
                x1="460.5"
                y1="650.5"
                x2="460.5"
                y2="44.5"
                stroke="#C4C4C4"
                stroke-linecap="round"
                stroke-dasharray="8 8"
              />
              <line
                x1="460.5"
                y1="650.5"
                x2="460.5"
                y2="44.5"
                stroke="#C4C4C4"
                stroke-linecap="round"
                stroke-dasharray="8 8"
              />
            </g>
            <g id="lines-1">
              <line
                x1="146.5"
                y1="650.5"
                x2="146.5"
                y2="44.5"
                stroke="#C4C4C4"
                stroke-linecap="round"
                stroke-dasharray="8 8"
              />
              <line
                x1="146.5"
                y1="650.5"
                x2="146.5"
                y2="44.5"
                stroke="#C4C4C4"
                stroke-linecap="round"
                stroke-dasharray="8 8"
              />
            </g>
            <g id="lines-3">
              <line
                x1="775.5"
                y1="650.5"
                x2="775.5"
                y2="44.5"
                stroke="#C4C4C4"
                stroke-linecap="round"
                stroke-dasharray="8 8"
              />
              <line
                x1="775.5"
                y1="650.5"
                x2="775.5"
                y2="44.5"
                stroke="#C4C4C4"
                stroke-linecap="round"
                stroke-dasharray="8 8"
              />
            </g>
            <g id="lines-4">
              <line
                x1="1090.5"
                y1="650.5"
                x2="1090.5"
                y2="44.5"
                stroke="#C4C4C4"
                stroke-linecap="round"
                stroke-dasharray="8 8"
              />
              <line
                x1="1090.5"
                y1="650.5"
                x2="1090.5"
                y2="44.5"
                stroke="#C4C4C4"
                stroke-linecap="round"
                stroke-dasharray="8 8"
              />
            </g>
          </g>
          <g
            id="step-1-bubble-group"
            class="transition-all origin-center"
            :class="[status.step1 ? 'animate--bounce-in' : 'opacity-0']"
          >
            <line
              id="step-1-bubble-connector"
              x1="146.5"
              y1="514.5"
              x2="146.5"
              y2="387.5"
              stroke="black"
              stroke-linecap="round"
              stroke-dasharray="8 8"
            />
            <g id="step-1-bubble-container">
              <g id="step-1-bubble-box" filter="url(#filter0_d_2182_39734)">
                <rect
                  x="53"
                  y="306"
                  width="190"
                  height="122"
                  rx="10"
                  fill="#221839"
                />
              </g>
              <g id="step-1-bubble-age">
                <path
                  id="20s"
                  d="M143.306 351.354V354H133.676L136.718 350.814C137.798 349.68 138.608 348.69 139.184 347.772C139.508 347.268 139.832 346.674 139.832 345.9C139.832 345.774 139.832 345.144 139.472 344.748C139.292 344.55 138.986 344.388 138.59 344.388C138.086 344.388 137.744 344.622 137.546 344.874C137.258 345.252 137.132 345.936 137.114 346.35H133.892C133.91 344.784 134.594 343.65 135.224 343.02C136.034 342.21 137.132 341.724 138.626 341.724C140.426 341.724 141.47 342.426 142.01 342.966C142.496 343.452 143.18 344.37 143.18 345.918C143.18 347.43 142.478 348.474 141.398 349.482L139.382 351.354H143.306ZM149.401 344.514C149.041 344.514 148.681 344.676 148.447 344.892C147.799 345.45 147.403 346.908 147.403 348.024C147.403 348.978 147.745 350.544 148.447 351.156C148.681 351.372 149.041 351.534 149.401 351.534C149.761 351.534 150.121 351.372 150.355 351.156C151.021 350.58 151.399 349.068 151.399 348.042C151.399 346.98 150.985 345.45 150.355 344.892C150.121 344.676 149.761 344.514 149.401 344.514ZM154.495 348.006C154.495 350.112 153.793 351.84 152.713 352.902C151.777 353.82 150.571 354.27 149.401 354.27C148.231 354.27 147.025 353.82 146.089 352.902C145.009 351.84 144.307 350.112 144.307 348.006C144.307 345.882 145.009 344.154 146.089 343.092C147.025 342.174 148.231 341.724 149.401 341.724C150.571 341.724 151.777 342.174 152.713 343.092C153.793 344.154 154.495 345.882 154.495 348.006ZM155.28 353.334L156.306 351.336C156.648 351.588 157.062 351.804 157.458 351.93C157.818 352.056 158.268 352.128 158.574 352.128C158.79 352.128 159.132 352.074 159.312 351.912C159.438 351.786 159.456 351.678 159.456 351.534C159.456 351.408 159.438 351.282 159.312 351.174C159.132 351.012 158.844 350.958 158.556 350.886L157.8 350.706C157.404 350.616 156.828 350.472 156.396 350.004C156.09 349.68 155.874 349.23 155.874 348.618C155.874 347.844 156.18 347.124 156.63 346.656C157.242 346.026 158.322 345.684 159.51 345.684C160.698 345.684 161.616 346.008 162.084 346.206L161.112 348.042C160.716 347.862 160.122 347.646 159.6 347.646C159.312 347.646 159.114 347.7 158.934 347.808C158.772 347.898 158.682 348.024 158.682 348.204C158.682 348.456 158.844 348.582 159.024 348.654C159.294 348.762 159.528 348.762 159.978 348.888L160.5 349.032C160.878 349.14 161.454 349.428 161.688 349.662C162.084 350.04 162.3 350.67 162.3 351.264C162.3 352.236 161.886 352.884 161.49 353.262C160.554 354.198 159.186 354.27 158.52 354.27C157.8 354.27 156.666 354.18 155.28 353.334Z"
                  fill="white"
                />
                <path
                  id="AGE"
                  d="M142.41 330L142 328.88H139.58L139.13 330H137.3L139.86 323.33H141.75L144.26 330H142.41ZM140.06 327.56H141.54L140.79 325.4L140.06 327.56ZM149.034 327.57V326.22H152.474C152.474 327.54 152.204 328.48 151.404 329.22C150.704 329.87 149.904 330.06 149.054 330.06C147.854 330.06 147.034 329.62 146.494 329.07C145.994 328.57 145.534 327.76 145.534 326.66C145.534 325.6 145.954 324.73 146.534 324.16C147.084 323.61 147.944 323.18 149.124 323.18C149.744 323.18 150.414 323.32 150.924 323.63C151.444 323.95 151.874 324.48 152.114 325L150.464 325.68C150.344 325.37 150.154 325.15 149.984 325.01C149.694 324.77 149.384 324.68 149.054 324.68C148.644 324.68 148.224 324.83 147.914 325.14C147.524 325.53 147.334 326.15 147.334 326.67C147.334 327.28 147.554 327.78 147.864 328.11C148.184 328.45 148.574 328.62 149.084 328.62C149.384 328.62 149.734 328.57 150.044 328.31C150.204 328.18 150.394 327.94 150.454 327.57H149.034ZM158.368 323.33V324.8H156.308V325.91H158.258V327.38H156.308V328.53H158.368V330H154.578V323.33H158.368Z"
                  fill="white"
                />
              </g>
              <g id="step-1-bubble-premium">
                <path
                  id="&#194;&#163;4"
                  d="M140.015 405.464H137.765V403.736H139.061C138.791 403.106 138.629 402.386 138.629 401.828C138.629 400.856 138.989 399.794 139.817 398.984C140.897 397.94 142.247 397.778 143.345 397.778C144.227 397.778 145.595 397.886 146.585 398.894C147.503 399.812 147.665 401.054 147.665 401.846C147.665 402.026 147.665 402.17 147.647 402.296H144.515C144.533 402.152 144.533 402.008 144.533 401.864C144.533 401.378 144.425 400.928 144.101 400.604C143.867 400.388 143.525 400.226 143.111 400.226C142.571 400.226 142.229 400.478 142.049 400.676C141.761 401 141.617 401.468 141.617 401.918C141.617 402.404 141.815 403.16 142.067 403.736H144.821V405.464H142.571C142.589 405.59 142.643 406.022 142.643 406.364C142.643 406.526 142.625 406.904 142.499 407.354L143.345 407.606C144.425 407.93 144.803 407.966 145.037 407.966C145.559 407.966 145.829 407.624 145.829 407.174H147.773C147.755 408.11 147.377 409.046 146.765 409.604C146.243 410.09 145.595 410.252 144.929 410.252C144.155 410.252 143.579 410.072 143.021 409.892L142.337 409.676C141.815 409.514 141.185 409.406 140.735 409.406C139.943 409.406 139.727 409.784 139.637 410H137.567C137.711 409.244 138.089 408.452 138.539 407.984C138.881 407.624 139.421 407.282 140.123 407.174C140.195 406.958 140.231 406.724 140.231 406.418C140.231 406.04 140.159 405.77 140.015 405.464ZM156.892 397.994V405.338H158.35V407.732H156.892V410H154.012V407.732H148.198V405.734L152.824 397.994H156.892ZM151.186 405.338H154.012V400.442L151.186 405.338Z"
                  fill="white"
                />
                <path
                  id="PREMIUM"
                  d="M126.827 383.79H125.737V386H124.007V379.33H126.767C127.347 379.33 127.947 379.44 128.457 379.93C128.977 380.43 129.077 380.99 129.077 381.55C129.077 382.08 129.007 382.7 128.487 383.21C127.967 383.72 127.347 383.79 126.827 383.79ZM125.737 380.73V382.39H126.317C126.497 382.39 126.837 382.37 127.047 382.18C127.257 382 127.267 381.73 127.267 381.57C127.267 381.39 127.247 381.15 127.067 380.97C126.867 380.76 126.547 380.73 126.327 380.73H125.737ZM130.994 379.33H133.694C134.194 379.33 134.834 379.41 135.324 379.92C135.704 380.31 135.894 380.89 135.894 381.42C135.894 381.99 135.694 382.49 135.364 382.81C135.104 383.06 134.754 383.21 134.444 383.27L136.534 386H134.384L132.724 383.44V386H130.994V379.33ZM132.724 380.67V382.32H133.054C133.314 382.32 133.684 382.25 133.894 382.05C134.024 381.92 134.114 381.7 134.114 381.49C134.114 381.29 134.034 381.07 133.884 380.93C133.724 380.77 133.434 380.67 133.054 380.67H132.724ZM142.053 379.33V380.8H139.993V381.91H141.943V383.38H139.993V384.53H142.053V386H138.263V379.33H142.053ZM145.576 386H143.856L144.986 379.33H146.696L148.046 382.89L149.476 379.33H151.206L152.206 386H150.476L149.986 382.16L148.376 386H147.686L146.146 382.16L145.576 386ZM154.306 379.33H156.036V386H154.306V379.33ZM158.441 379.33H160.171V383.28C160.171 383.56 160.181 383.99 160.511 384.31C160.711 384.5 161.031 384.63 161.331 384.63C161.631 384.63 161.941 384.51 162.131 384.34C162.531 383.99 162.521 383.5 162.521 383.13V379.33H164.251V383.16C164.251 383.86 164.221 384.59 163.501 385.32C162.941 385.89 162.241 386.15 161.301 386.15C160.251 386.15 159.501 385.79 159.091 385.35C158.511 384.72 158.441 383.87 158.441 383.16V379.33ZM168.068 386H166.348L167.478 379.33H169.188L170.538 382.89L171.968 379.33H173.698L174.698 386H172.968L172.478 382.16L170.868 386H170.178L168.638 382.16L168.068 386Z"
                  fill="white"
                />
              </g>
              <line
                id="step-1-bubble-divider"
                x1="243"
                y1="367.25"
                x2="53"
                y2="367.25"
                stroke="white"
                stroke-width="0.5"
              />
            </g>
          </g>
          <g
            id="step-2-bubble-group"
            class="transition-all"
            :class="[status.step2 ? 'animate--bounce-in' : 'opacity-0']"
          >
            <line
              id="step-2-bubble-connector"
              x1="460.5"
              y1="454.5"
              x2="460.5"
              y2="327.5"
              stroke="black"
              stroke-linecap="round"
              stroke-dasharray="8 8"
            />
            <g id="step-2-bubble-container">
              <g id="step-2-bubble-box" filter="url(#filter1_d_2182_39734)">
                <rect
                  x="367"
                  y="246"
                  width="190"
                  height="122"
                  rx="10"
                  fill="#221839"
                />
              </g>
              <g id="step-2-bubble-age">
                <path
                  id="30s"
                  d="M447.712 289.896H450.898C450.916 290.346 451.096 290.814 451.384 291.102C451.654 291.39 452.086 291.57 452.608 291.57C453.22 291.57 453.598 291.3 453.832 291.048C454.102 290.742 454.192 290.418 454.192 290.058C454.192 289.536 453.94 289.176 453.724 288.996C453.418 288.744 452.95 288.654 452.572 288.654C452.374 288.654 452.212 288.672 452.05 288.726V286.62C452.68 286.71 453.076 286.53 453.328 286.314C453.616 286.062 453.724 285.738 453.724 285.468C453.724 285.144 453.58 284.784 453.4 284.604C453.202 284.406 452.86 284.28 452.518 284.28C452.14 284.28 451.834 284.406 451.654 284.586C451.384 284.838 451.24 285.27 451.24 285.648H448.342C448.414 284.388 448.972 283.434 449.512 282.894C450.394 281.976 451.528 281.724 452.68 281.724C453.58 281.724 454.768 281.904 455.668 282.786C456.262 283.38 456.64 284.19 456.64 285.108C456.64 285.63 456.55 286.098 456.28 286.584C456.064 286.98 455.794 287.286 455.362 287.502C456.1 287.772 456.532 288.24 456.784 288.6C457.126 289.104 457.288 289.68 457.288 290.364C457.288 291.642 456.73 292.488 456.226 292.992C455.578 293.64 454.426 294.27 452.644 294.27C451.492 294.27 450.25 294 449.206 293.028C448.594 292.47 447.856 291.444 447.712 289.896ZM463.401 284.514C463.041 284.514 462.681 284.676 462.447 284.892C461.799 285.45 461.403 286.908 461.403 288.024C461.403 288.978 461.745 290.544 462.447 291.156C462.681 291.372 463.041 291.534 463.401 291.534C463.761 291.534 464.121 291.372 464.355 291.156C465.021 290.58 465.399 289.068 465.399 288.042C465.399 286.98 464.985 285.45 464.355 284.892C464.121 284.676 463.761 284.514 463.401 284.514ZM468.495 288.006C468.495 290.112 467.793 291.84 466.713 292.902C465.777 293.82 464.571 294.27 463.401 294.27C462.231 294.27 461.025 293.82 460.089 292.902C459.009 291.84 458.307 290.112 458.307 288.006C458.307 285.882 459.009 284.154 460.089 283.092C461.025 282.174 462.231 281.724 463.401 281.724C464.571 281.724 465.777 282.174 466.713 283.092C467.793 284.154 468.495 285.882 468.495 288.006ZM469.28 293.334L470.306 291.336C470.648 291.588 471.062 291.804 471.458 291.93C471.818 292.056 472.268 292.128 472.574 292.128C472.79 292.128 473.132 292.074 473.312 291.912C473.438 291.786 473.456 291.678 473.456 291.534C473.456 291.408 473.438 291.282 473.312 291.174C473.132 291.012 472.844 290.958 472.556 290.886L471.8 290.706C471.404 290.616 470.828 290.472 470.396 290.004C470.09 289.68 469.874 289.23 469.874 288.618C469.874 287.844 470.18 287.124 470.63 286.656C471.242 286.026 472.322 285.684 473.51 285.684C474.698 285.684 475.616 286.008 476.084 286.206L475.112 288.042C474.716 287.862 474.122 287.646 473.6 287.646C473.312 287.646 473.114 287.7 472.934 287.808C472.772 287.898 472.682 288.024 472.682 288.204C472.682 288.456 472.844 288.582 473.024 288.654C473.294 288.762 473.528 288.762 473.978 288.888L474.5 289.032C474.878 289.14 475.454 289.428 475.688 289.662C476.084 290.04 476.3 290.67 476.3 291.264C476.3 292.236 475.886 292.884 475.49 293.262C474.554 294.198 473.186 294.27 472.52 294.27C471.8 294.27 470.666 294.18 469.28 293.334Z"
                  fill="white"
                />
                <path
                  id="AGE_2"
                  d="M456.41 270L456 268.88H453.58L453.13 270H451.3L453.86 263.33H455.75L458.26 270H456.41ZM454.06 267.56H455.54L454.79 265.4L454.06 267.56ZM463.034 267.57V266.22H466.474C466.474 267.54 466.204 268.48 465.404 269.22C464.704 269.87 463.904 270.06 463.054 270.06C461.854 270.06 461.034 269.62 460.494 269.07C459.994 268.57 459.534 267.76 459.534 266.66C459.534 265.6 459.954 264.73 460.534 264.16C461.084 263.61 461.944 263.18 463.124 263.18C463.744 263.18 464.414 263.32 464.924 263.63C465.444 263.95 465.874 264.48 466.114 265L464.464 265.68C464.344 265.37 464.154 265.15 463.984 265.01C463.694 264.77 463.384 264.68 463.054 264.68C462.644 264.68 462.224 264.83 461.914 265.14C461.524 265.53 461.334 266.15 461.334 266.67C461.334 267.28 461.554 267.78 461.864 268.11C462.184 268.45 462.574 268.62 463.084 268.62C463.384 268.62 463.734 268.57 464.044 268.31C464.204 268.18 464.394 267.94 464.454 267.57H463.034ZM472.368 263.33V264.8H470.308V265.91H472.258V267.38H470.308V268.53H472.368V270H468.578V263.33H472.368Z"
                  fill="white"
                />
              </g>
              <g id="step-2-bubble-premium">
                <path
                  id="&#194;&#163;6"
                  d="M454.015 345.464H451.765V343.736H453.061C452.791 343.106 452.629 342.386 452.629 341.828C452.629 340.856 452.989 339.794 453.817 338.984C454.897 337.94 456.247 337.778 457.345 337.778C458.227 337.778 459.595 337.886 460.585 338.894C461.503 339.812 461.665 341.054 461.665 341.846C461.665 342.026 461.665 342.17 461.647 342.296H458.515C458.533 342.152 458.533 342.008 458.533 341.864C458.533 341.378 458.425 340.928 458.101 340.604C457.867 340.388 457.525 340.226 457.111 340.226C456.571 340.226 456.229 340.478 456.049 340.676C455.761 341 455.617 341.468 455.617 341.918C455.617 342.404 455.815 343.16 456.067 343.736H458.821V345.464H456.571C456.589 345.59 456.643 346.022 456.643 346.364C456.643 346.526 456.625 346.904 456.499 347.354L457.345 347.606C458.425 347.93 458.803 347.966 459.037 347.966C459.559 347.966 459.829 347.624 459.829 347.174H461.773C461.755 348.11 461.377 349.046 460.765 349.604C460.243 350.09 459.595 350.252 458.929 350.252C458.155 350.252 457.579 350.072 457.021 349.892L456.337 349.676C455.815 349.514 455.185 349.406 454.735 349.406C453.943 349.406 453.727 349.784 453.637 350H451.567C451.711 349.244 452.089 348.452 452.539 347.984C452.881 347.624 453.421 347.282 454.123 347.174C454.195 346.958 454.231 346.724 454.231 346.418C454.231 346.04 454.159 345.77 454.015 345.464ZM466.806 337.994H470.352L466.932 342.08C467.418 341.864 468.012 341.702 468.606 341.702C469.506 341.702 470.532 342.062 471.324 342.854C472.17 343.7 472.458 344.69 472.458 345.716C472.458 346.832 472.152 347.912 471.216 348.848C470.028 350.036 468.534 350.27 467.382 350.27C465.312 350.27 464.106 349.496 463.44 348.812C462.864 348.218 462.342 347.3 462.342 346.004C462.342 344.366 463.17 342.782 464.124 341.522L466.806 337.994ZM467.328 347.804C467.994 347.804 468.444 347.516 468.714 347.246C469.056 346.904 469.272 346.418 469.272 345.878C469.272 345.5 469.146 345.032 468.714 344.618C468.228 344.15 467.688 344.06 467.328 344.06C466.86 344.06 466.338 344.258 465.978 344.582C465.6 344.924 465.384 345.41 465.384 345.824C465.384 346.328 465.564 346.832 465.906 347.192C466.374 347.678 466.932 347.804 467.328 347.804Z"
                  fill="white"
                />
                <path
                  id="PREMIUM_2"
                  d="M440.827 323.79H439.737V326H438.007V319.33H440.767C441.347 319.33 441.947 319.44 442.457 319.93C442.977 320.43 443.077 320.99 443.077 321.55C443.077 322.08 443.007 322.7 442.487 323.21C441.967 323.72 441.347 323.79 440.827 323.79ZM439.737 320.73V322.39H440.317C440.497 322.39 440.837 322.37 441.047 322.18C441.257 322 441.267 321.73 441.267 321.57C441.267 321.39 441.247 321.15 441.067 320.97C440.867 320.76 440.547 320.73 440.327 320.73H439.737ZM444.994 319.33H447.694C448.194 319.33 448.834 319.41 449.324 319.92C449.704 320.31 449.894 320.89 449.894 321.42C449.894 321.99 449.694 322.49 449.364 322.81C449.104 323.06 448.754 323.21 448.444 323.27L450.534 326H448.384L446.724 323.44V326H444.994V319.33ZM446.724 320.67V322.32H447.054C447.314 322.32 447.684 322.25 447.894 322.05C448.024 321.92 448.114 321.7 448.114 321.49C448.114 321.29 448.034 321.07 447.884 320.93C447.724 320.77 447.434 320.67 447.054 320.67H446.724ZM456.053 319.33V320.8H453.993V321.91H455.943V323.38H453.993V324.53H456.053V326H452.263V319.33H456.053ZM459.576 326H457.856L458.986 319.33H460.696L462.046 322.89L463.476 319.33H465.206L466.206 326H464.476L463.986 322.16L462.376 326H461.686L460.146 322.16L459.576 326ZM468.306 319.33H470.036V326H468.306V319.33ZM472.441 319.33H474.171V323.28C474.171 323.56 474.181 323.99 474.511 324.31C474.711 324.5 475.031 324.63 475.331 324.63C475.631 324.63 475.941 324.51 476.131 324.34C476.531 323.99 476.521 323.5 476.521 323.13V319.33H478.251V323.16C478.251 323.86 478.221 324.59 477.501 325.32C476.941 325.89 476.241 326.15 475.301 326.15C474.251 326.15 473.501 325.79 473.091 325.35C472.511 324.72 472.441 323.87 472.441 323.16V319.33ZM482.068 326H480.348L481.478 319.33H483.188L484.538 322.89L485.968 319.33H487.698L488.698 326H486.968L486.478 322.16L484.868 326H484.178L482.638 322.16L482.068 326Z"
                  fill="white"
                />
              </g>
              <line
                id="step-2-bubble-divider"
                x1="557"
                y1="307.25"
                x2="367"
                y2="307.25"
                stroke="white"
                stroke-width="0.5"
              />
            </g>
          </g>
          <g
            id="step-3-bubble"
            class="transition-all"
            :class="[status.step3 ? 'animate--bounce-in' : 'opacity-0']"
          >
            <line
              id="step-3-bubble-connector"
              x1="775.5"
              y1="483.5"
              x2="775.5"
              y2="356.5"
              stroke="black"
              stroke-linecap="round"
              stroke-dasharray="8 8"
            />
            <g id="step-3-bubble-container">
              <g id="step-3-bubble-box" filter="url(#filter2_d_2182_39734)">
                <rect
                  x="682"
                  y="477"
                  width="190"
                  height="122"
                  rx="10"
                  fill="#221839"
                />
              </g>
              <g id="step-3-bubble-age">
                <path
                  id="40s"
                  d="M771.1 512.994V520.338H772.558V522.732H771.1V525H768.22V522.732H762.406V520.734L767.032 512.994H771.1ZM765.394 520.338H768.22V515.442L765.394 520.338ZM778.401 515.514C778.041 515.514 777.681 515.676 777.447 515.892C776.799 516.45 776.403 517.908 776.403 519.024C776.403 519.978 776.745 521.544 777.447 522.156C777.681 522.372 778.041 522.534 778.401 522.534C778.761 522.534 779.121 522.372 779.355 522.156C780.021 521.58 780.399 520.068 780.399 519.042C780.399 517.98 779.985 516.45 779.355 515.892C779.121 515.676 778.761 515.514 778.401 515.514ZM783.495 519.006C783.495 521.112 782.793 522.84 781.713 523.902C780.777 524.82 779.571 525.27 778.401 525.27C777.231 525.27 776.025 524.82 775.089 523.902C774.009 522.84 773.307 521.112 773.307 519.006C773.307 516.882 774.009 515.154 775.089 514.092C776.025 513.174 777.231 512.724 778.401 512.724C779.571 512.724 780.777 513.174 781.713 514.092C782.793 515.154 783.495 516.882 783.495 519.006ZM784.28 524.334L785.306 522.336C785.648 522.588 786.062 522.804 786.458 522.93C786.818 523.056 787.268 523.128 787.574 523.128C787.79 523.128 788.132 523.074 788.312 522.912C788.438 522.786 788.456 522.678 788.456 522.534C788.456 522.408 788.438 522.282 788.312 522.174C788.132 522.012 787.844 521.958 787.556 521.886L786.8 521.706C786.404 521.616 785.828 521.472 785.396 521.004C785.09 520.68 784.874 520.23 784.874 519.618C784.874 518.844 785.18 518.124 785.63 517.656C786.242 517.026 787.322 516.684 788.51 516.684C789.698 516.684 790.616 517.008 791.084 517.206L790.112 519.042C789.716 518.862 789.122 518.646 788.6 518.646C788.312 518.646 788.114 518.7 787.934 518.808C787.772 518.898 787.682 519.024 787.682 519.204C787.682 519.456 787.844 519.582 788.024 519.654C788.294 519.762 788.528 519.762 788.978 519.888L789.5 520.032C789.878 520.14 790.454 520.428 790.688 520.662C791.084 521.04 791.3 521.67 791.3 522.264C791.3 523.236 790.886 523.884 790.49 524.262C789.554 525.198 788.186 525.27 787.52 525.27C786.8 525.27 785.666 525.18 784.28 524.334Z"
                  fill="white"
                />
                <path
                  id="AGE_3"
                  d="M771.41 501L771 499.88H768.58L768.13 501H766.3L768.86 494.33H770.75L773.26 501H771.41ZM769.06 498.56H770.54L769.79 496.4L769.06 498.56ZM778.034 498.57V497.22H781.474C781.474 498.54 781.204 499.48 780.404 500.22C779.704 500.87 778.904 501.06 778.054 501.06C776.854 501.06 776.034 500.62 775.494 500.07C774.994 499.57 774.534 498.76 774.534 497.66C774.534 496.6 774.954 495.73 775.534 495.16C776.084 494.61 776.944 494.18 778.124 494.18C778.744 494.18 779.414 494.32 779.924 494.63C780.444 494.95 780.874 495.48 781.114 496L779.464 496.68C779.344 496.37 779.154 496.15 778.984 496.01C778.694 495.77 778.384 495.68 778.054 495.68C777.644 495.68 777.224 495.83 776.914 496.14C776.524 496.53 776.334 497.15 776.334 497.67C776.334 498.28 776.554 498.78 776.864 499.11C777.184 499.45 777.574 499.62 778.084 499.62C778.384 499.62 778.734 499.57 779.044 499.31C779.204 499.18 779.394 498.94 779.454 498.57H778.034ZM787.368 494.33V495.8H785.308V496.91H787.258V498.38H785.308V499.53H787.368V501H783.578V494.33H787.368Z"
                  fill="white"
                />
              </g>
              <g id="step-3-bubble-premium">
                <path
                  id="&#194;&#163;12"
                  d="M764.744 576.464H762.494V574.736H763.79C763.52 574.106 763.358 573.386 763.358 572.828C763.358 571.856 763.718 570.794 764.546 569.984C765.626 568.94 766.976 568.778 768.074 568.778C768.956 568.778 770.324 568.886 771.314 569.894C772.232 570.812 772.394 572.054 772.394 572.846C772.394 573.026 772.394 573.17 772.376 573.296H769.244C769.262 573.152 769.262 573.008 769.262 572.864C769.262 572.378 769.154 571.928 768.83 571.604C768.596 571.388 768.254 571.226 767.84 571.226C767.3 571.226 766.958 571.478 766.778 571.676C766.49 572 766.346 572.468 766.346 572.918C766.346 573.404 766.544 574.16 766.796 574.736H769.55V576.464H767.3C767.318 576.59 767.372 577.022 767.372 577.364C767.372 577.526 767.354 577.904 767.228 578.354L768.074 578.606C769.154 578.93 769.532 578.966 769.766 578.966C770.288 578.966 770.558 578.624 770.558 578.174H772.502C772.484 579.11 772.106 580.046 771.494 580.604C770.972 581.09 770.324 581.252 769.658 581.252C768.884 581.252 768.308 581.072 767.75 580.892L767.066 580.676C766.544 580.514 765.914 580.406 765.464 580.406C764.672 580.406 764.456 580.784 764.366 581H762.296C762.44 580.244 762.818 579.452 763.268 578.984C763.61 578.624 764.15 578.282 764.852 578.174C764.924 577.958 764.96 577.724 764.96 577.418C764.96 577.04 764.888 576.77 764.744 576.464ZM776.941 581V571.64H775.231V568.994H780.055V581H776.941ZM791.37 578.354V581H781.74L784.782 577.814C785.862 576.68 786.672 575.69 787.248 574.772C787.572 574.268 787.896 573.674 787.896 572.9C787.896 572.774 787.896 572.144 787.536 571.748C787.356 571.55 787.05 571.388 786.654 571.388C786.15 571.388 785.808 571.622 785.61 571.874C785.322 572.252 785.196 572.936 785.178 573.35H781.956C781.974 571.784 782.658 570.65 783.288 570.02C784.098 569.21 785.196 568.724 786.69 568.724C788.49 568.724 789.534 569.426 790.074 569.966C790.56 570.452 791.244 571.37 791.244 572.918C791.244 574.43 790.542 575.474 789.462 576.482L787.446 578.354H791.37Z"
                  fill="white"
                />
                <path
                  id="PREMIUM_3"
                  d="M755.827 554.79H754.737V557H753.007V550.33H755.767C756.347 550.33 756.947 550.44 757.457 550.93C757.977 551.43 758.077 551.99 758.077 552.55C758.077 553.08 758.007 553.7 757.487 554.21C756.967 554.72 756.347 554.79 755.827 554.79ZM754.737 551.73V553.39H755.317C755.497 553.39 755.837 553.37 756.047 553.18C756.257 553 756.267 552.73 756.267 552.57C756.267 552.39 756.247 552.15 756.067 551.97C755.867 551.76 755.547 551.73 755.327 551.73H754.737ZM759.994 550.33H762.694C763.194 550.33 763.834 550.41 764.324 550.92C764.704 551.31 764.894 551.89 764.894 552.42C764.894 552.99 764.694 553.49 764.364 553.81C764.104 554.06 763.754 554.21 763.444 554.27L765.534 557H763.384L761.724 554.44V557H759.994V550.33ZM761.724 551.67V553.32H762.054C762.314 553.32 762.684 553.25 762.894 553.05C763.024 552.92 763.114 552.7 763.114 552.49C763.114 552.29 763.034 552.07 762.884 551.93C762.724 551.77 762.434 551.67 762.054 551.67H761.724ZM771.053 550.33V551.8H768.993V552.91H770.943V554.38H768.993V555.53H771.053V557H767.263V550.33H771.053ZM774.576 557H772.856L773.986 550.33H775.696L777.046 553.89L778.476 550.33H780.206L781.206 557H779.476L778.986 553.16L777.376 557H776.686L775.146 553.16L774.576 557ZM783.306 550.33H785.036V557H783.306V550.33ZM787.441 550.33H789.171V554.28C789.171 554.56 789.181 554.99 789.511 555.31C789.711 555.5 790.031 555.63 790.331 555.63C790.631 555.63 790.941 555.51 791.131 555.34C791.531 554.99 791.521 554.5 791.521 554.13V550.33H793.251V554.16C793.251 554.86 793.221 555.59 792.501 556.32C791.941 556.89 791.241 557.15 790.301 557.15C789.251 557.15 788.501 556.79 788.091 556.35C787.511 555.72 787.441 554.87 787.441 554.16V550.33ZM797.068 557H795.348L796.478 550.33H798.188L799.538 553.89L800.968 550.33H802.698L803.698 557H801.968L801.478 553.16L799.868 557H799.178L797.638 553.16L797.068 557Z"
                  fill="white"
                />
              </g>
              <line
                id="step-3-bubble-divider"
                x1="872"
                y1="538.25"
                x2="682"
                y2="538.25"
                stroke="white"
                stroke-width="0.5"
              />
            </g>
          </g>
          <g
            id="step-4-bubble-group"
            class="transition-all"
            :class="[status.step4 ? 'animate--bounce-in' : 'opacity-0']"
          >
            <line
              id="step-4-bubble-connector"
              x1="1090.5"
              y1="271.608"
              x2="1090.5"
              y2="144.608"
              stroke="black"
              stroke-linecap="round"
              stroke-dasharray="8 8"
            />
            <g id="step-4-bubble-container">
              <g id="step-4-bubble-box" filter="url(#filter3_d_2182_39734)">
                <rect
                  x="997"
                  y="235.108"
                  width="190"
                  height="122"
                  rx="10"
                  fill="#221839"
                />
              </g>
              <g id="step-4-bubble-age">
                <path
                  id="50s"
                  d="M1086.12 271.102V273.748H1081.96L1081.74 275.08C1082.19 275.008 1082.55 274.99 1082.72 274.99C1084.32 274.99 1085.33 275.602 1085.88 276.178C1086.42 276.718 1086.98 277.636 1086.98 279.022C1086.98 280.462 1086.41 281.434 1085.83 282.028C1084.71 283.18 1083.24 283.378 1082.09 283.378C1080.27 283.378 1079.01 282.91 1078.04 282.298L1078.5 279.382C1079.13 279.958 1079.75 280.264 1079.94 280.354C1080.48 280.606 1081.15 280.768 1081.74 280.768C1082.37 280.768 1082.95 280.552 1083.31 280.174C1083.58 279.886 1083.78 279.454 1083.78 278.95C1083.78 278.32 1083.47 277.888 1083.2 277.654C1082.55 277.078 1081.44 277.06 1081.04 277.06C1080.2 277.06 1079.48 277.24 1078.83 277.564L1079.87 271.102H1086.12ZM1093.4 273.622C1093.04 273.622 1092.68 273.784 1092.45 274C1091.8 274.558 1091.4 276.016 1091.4 277.132C1091.4 278.086 1091.75 279.652 1092.45 280.264C1092.68 280.48 1093.04 280.642 1093.4 280.642C1093.76 280.642 1094.12 280.48 1094.36 280.264C1095.02 279.688 1095.4 278.176 1095.4 277.15C1095.4 276.088 1094.99 274.558 1094.36 274C1094.12 273.784 1093.76 273.622 1093.4 273.622ZM1098.5 277.114C1098.5 279.22 1097.79 280.948 1096.71 282.01C1095.78 282.928 1094.57 283.378 1093.4 283.378C1092.23 283.378 1091.03 282.928 1090.09 282.01C1089.01 280.948 1088.31 279.22 1088.31 277.114C1088.31 274.99 1089.01 273.262 1090.09 272.2C1091.03 271.282 1092.23 270.832 1093.4 270.832C1094.57 270.832 1095.78 271.282 1096.71 272.2C1097.79 273.262 1098.5 274.99 1098.5 277.114ZM1099.28 282.442L1100.31 280.444C1100.65 280.696 1101.06 280.912 1101.46 281.038C1101.82 281.164 1102.27 281.236 1102.57 281.236C1102.79 281.236 1103.13 281.182 1103.31 281.02C1103.44 280.894 1103.46 280.786 1103.46 280.642C1103.46 280.516 1103.44 280.39 1103.31 280.282C1103.13 280.12 1102.84 280.066 1102.56 279.994L1101.8 279.814C1101.4 279.724 1100.83 279.58 1100.4 279.112C1100.09 278.788 1099.87 278.338 1099.87 277.726C1099.87 276.952 1100.18 276.232 1100.63 275.764C1101.24 275.134 1102.32 274.792 1103.51 274.792C1104.7 274.792 1105.62 275.116 1106.08 275.314L1105.11 277.15C1104.72 276.97 1104.12 276.754 1103.6 276.754C1103.31 276.754 1103.11 276.808 1102.93 276.916C1102.77 277.006 1102.68 277.132 1102.68 277.312C1102.68 277.564 1102.84 277.69 1103.02 277.762C1103.29 277.87 1103.53 277.87 1103.98 277.996L1104.5 278.14C1104.88 278.248 1105.45 278.536 1105.69 278.77C1106.08 279.148 1106.3 279.778 1106.3 280.372C1106.3 281.344 1105.89 281.992 1105.49 282.37C1104.55 283.306 1103.19 283.378 1102.52 283.378C1101.8 283.378 1100.67 283.288 1099.28 282.442Z"
                  fill="white"
                />
                <path
                  id="AGE_4"
                  d="M1086.41 259.108L1086 257.988H1083.58L1083.13 259.108H1081.3L1083.86 252.438H1085.75L1088.26 259.108H1086.41ZM1084.06 256.668H1085.54L1084.79 254.508L1084.06 256.668ZM1093.03 256.678V255.328H1096.47C1096.47 256.648 1096.2 257.588 1095.4 258.328C1094.7 258.978 1093.9 259.168 1093.05 259.168C1091.85 259.168 1091.03 258.728 1090.49 258.178C1089.99 257.678 1089.53 256.868 1089.53 255.768C1089.53 254.708 1089.95 253.838 1090.53 253.268C1091.08 252.718 1091.94 252.288 1093.12 252.288C1093.74 252.288 1094.41 252.428 1094.92 252.738C1095.44 253.058 1095.87 253.588 1096.11 254.108L1094.46 254.788C1094.34 254.478 1094.15 254.258 1093.98 254.118C1093.69 253.878 1093.38 253.788 1093.05 253.788C1092.64 253.788 1092.22 253.938 1091.91 254.248C1091.52 254.638 1091.33 255.258 1091.33 255.778C1091.33 256.388 1091.55 256.888 1091.86 257.218C1092.18 257.558 1092.57 257.728 1093.08 257.728C1093.38 257.728 1093.73 257.678 1094.04 257.418C1094.2 257.288 1094.39 257.048 1094.45 256.678H1093.03ZM1102.37 252.438V253.908H1100.31V255.018H1102.26V256.488H1100.31V257.638H1102.37V259.108H1098.58V252.438H1102.37Z"
                  fill="white"
                />
              </g>
              <g id="step-4-bubble-premium">
                <path
                  id="&#194;&#163;27"
                  d="M1078.85 334.572H1076.6V332.844H1077.89C1077.62 332.214 1077.46 331.494 1077.46 330.936C1077.46 329.964 1077.82 328.902 1078.65 328.092C1079.73 327.048 1081.08 326.886 1082.18 326.886C1083.06 326.886 1084.43 326.994 1085.42 328.002C1086.34 328.92 1086.5 330.162 1086.5 330.954C1086.5 331.134 1086.5 331.278 1086.48 331.404H1083.35C1083.37 331.26 1083.37 331.116 1083.37 330.972C1083.37 330.486 1083.26 330.036 1082.93 329.712C1082.7 329.496 1082.36 329.334 1081.94 329.334C1081.4 329.334 1081.06 329.586 1080.88 329.784C1080.59 330.108 1080.45 330.576 1080.45 331.026C1080.45 331.512 1080.65 332.268 1080.9 332.844H1083.65V334.572H1081.4C1081.42 334.698 1081.48 335.13 1081.48 335.472C1081.48 335.634 1081.46 336.012 1081.33 336.462L1082.18 336.714C1083.26 337.038 1083.64 337.074 1083.87 337.074C1084.39 337.074 1084.66 336.732 1084.66 336.282H1086.61C1086.59 337.218 1086.21 338.154 1085.6 338.712C1085.08 339.198 1084.43 339.36 1083.76 339.36C1082.99 339.36 1082.41 339.18 1081.85 339L1081.17 338.784C1080.65 338.622 1080.02 338.514 1079.57 338.514C1078.78 338.514 1078.56 338.892 1078.47 339.108H1076.4C1076.54 338.352 1076.92 337.56 1077.37 337.092C1077.71 336.732 1078.25 336.39 1078.96 336.282C1079.03 336.066 1079.06 335.832 1079.06 335.526C1079.06 335.148 1078.99 334.878 1078.85 334.572ZM1096.93 336.462V339.108H1087.3L1090.34 335.922C1091.42 334.788 1092.23 333.798 1092.81 332.88C1093.13 332.376 1093.46 331.782 1093.46 331.008C1093.46 330.882 1093.46 330.252 1093.1 329.856C1092.92 329.658 1092.61 329.496 1092.21 329.496C1091.71 329.496 1091.37 329.73 1091.17 329.982C1090.88 330.36 1090.76 331.044 1090.74 331.458H1087.52C1087.53 329.892 1088.22 328.758 1088.85 328.128C1089.66 327.318 1090.76 326.832 1092.25 326.832C1094.05 326.832 1095.09 327.534 1095.63 328.074C1096.12 328.56 1096.8 329.478 1096.8 331.026C1096.8 332.538 1096.1 333.582 1095.02 334.59L1093.01 336.462H1096.93ZM1098.21 339.108L1103.68 329.748H1098.68V327.102H1108.53L1101.65 339.108H1098.21Z"
                  fill="white"
                />
                <path
                  id="PREMIUM_4"
                  d="M1070.83 312.898H1069.74V315.108H1068.01V308.438H1070.77C1071.35 308.438 1071.95 308.548 1072.46 309.038C1072.98 309.538 1073.08 310.098 1073.08 310.658C1073.08 311.188 1073.01 311.808 1072.49 312.318C1071.97 312.828 1071.35 312.898 1070.83 312.898ZM1069.74 309.838V311.498H1070.32C1070.5 311.498 1070.84 311.478 1071.05 311.288C1071.26 311.108 1071.27 310.838 1071.27 310.678C1071.27 310.498 1071.25 310.258 1071.07 310.078C1070.87 309.868 1070.55 309.838 1070.33 309.838H1069.74ZM1074.99 308.438H1077.69C1078.19 308.438 1078.83 308.518 1079.32 309.028C1079.7 309.418 1079.89 309.998 1079.89 310.528C1079.89 311.098 1079.69 311.598 1079.36 311.918C1079.1 312.168 1078.75 312.318 1078.44 312.378L1080.53 315.108H1078.38L1076.72 312.548V315.108H1074.99V308.438ZM1076.72 309.778V311.428H1077.05C1077.31 311.428 1077.68 311.358 1077.89 311.158C1078.02 311.028 1078.11 310.808 1078.11 310.598C1078.11 310.398 1078.03 310.178 1077.88 310.038C1077.72 309.878 1077.43 309.778 1077.05 309.778H1076.72ZM1086.05 308.438V309.908H1083.99V311.018H1085.94V312.488H1083.99V313.638H1086.05V315.108H1082.26V308.438H1086.05ZM1089.58 315.108H1087.86L1088.99 308.438H1090.7L1092.05 311.998L1093.48 308.438H1095.21L1096.21 315.108H1094.48L1093.99 311.268L1092.38 315.108H1091.69L1090.15 311.268L1089.58 315.108ZM1098.31 308.438H1100.04V315.108H1098.31V308.438ZM1102.44 308.438H1104.17V312.388C1104.17 312.668 1104.18 313.098 1104.51 313.418C1104.71 313.608 1105.03 313.738 1105.33 313.738C1105.63 313.738 1105.94 313.618 1106.13 313.448C1106.53 313.098 1106.52 312.608 1106.52 312.238V308.438H1108.25V312.268C1108.25 312.968 1108.22 313.698 1107.5 314.428C1106.94 314.998 1106.24 315.258 1105.3 315.258C1104.25 315.258 1103.5 314.898 1103.09 314.458C1102.51 313.828 1102.44 312.978 1102.44 312.268V308.438ZM1112.07 315.108H1110.35L1111.48 308.438H1113.19L1114.54 311.998L1115.97 308.438H1117.7L1118.7 315.108H1116.97L1116.48 311.268L1114.87 315.108H1114.18L1112.64 311.268L1112.07 315.108Z"
                  fill="white"
                />
              </g>
              <line
                id="step-4-bubble-divider"
                x1="1187"
                y1="296.358"
                x2="997"
                y2="296.358"
                stroke="white"
                stroke-width="0.5"
              />
            </g>
          </g>
          <path
            id="line-timeline"
            d="M148.5 546L462 479L774 329.5L1088.5 109"
            stroke="#8457E8"
            stroke-width="4"
            stroke-linecap="round"
          />
          <g
            id="step-1-dot-group"
            class="cursor-pointer"
            @click="toggleBox('step1')"
          >
            <circle
              id="step-1-dot-3"
              opacity="0.2"
              cx="148"
              cy="548.3"
              r="40"
              fill="#8457E8"
              class="animate-pulse delay-500"
            />
            <circle
              id="step-1-dot-2"
              opacity="0.5"
              cx="147.999"
              cy="548.3"
              r="30"
              fill="#8457E8"
              class="animate-pulse delay-250"
            />
            <circle
              id="step-1-dot-1"
              cx="148"
              cy="548.3"
              r="20"
              fill="#8457E8"
              class="animate-pulse"
            />
          </g>
          <g
            id="step-2-dot-group"
            class="cursor-pointer"
            @click="toggleBox('step2')"
          >
            <circle
              id="step-2-dot-3"
              opacity="0.2"
              cx="462"
              cy="482.696"
              r="40"
              fill="#8457E8"
              class="animate-pulse delay-[2000]"
            />
            <circle
              id="step-2-dot-2"
              opacity="0.5"
              cx="461.999"
              cy="482.696"
              r="30"
              fill="#8457E8"
              class="animate-pulse delay-[1500]"
            />
            <circle
              id="step-2-dot-1"
              cx="462.001"
              cy="482.696"
              r="20"
              fill="#8457E8"
              class="animate-pulse delay-[1250]"
            />
          </g>
          <g
            id="step-3-dot-group"
            class="cursor-pointer"
            @click="toggleBox('step3')"
          >
            <circle
              id="step-3-dot-3"
              opacity="0.2"
              cx="777"
              cy="327.092"
              r="40"
              fill="#8457E8"
              class="animate-pulse delay-[2750]"
            />
            <circle
              id="step-3-dot-2"
              opacity="0.5"
              cx="777"
              cy="327.092"
              r="30"
              fill="#8457E8"
              class="animate-pulse delay-[2500]"
            />
            <circle
              id="step-3-dot-1"
              cx="777.001"
              cy="327.092"
              r="20"
              fill="#8457E8"
              class="animate-pulse delay-[2250]"
            />
          </g>
          <g
            id="step-4-dot-group"
            class="cursor-pointer"
            @click="toggleBox('step4')"
          >
            <circle
              id="step-4-dot-3"
              opacity="0.2"
              cx="1092"
              cy="109"
              r="40"
              fill="#8457E8"
              class="animate-pulse delay-[3750]"
            />
            <circle
              id="step-4-dot-2"
              opacity="0.5"
              cx="1092"
              cy="109"
              r="30"
              fill="#8457E8"
              class="animate-pulse delay-[3500]"
            />
            <circle
              id="step-4-dot-1"
              cx="1092"
              cy="109"
              r="20"
              fill="#8457E8"
              class="animate-pulse delay-[3250]"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_2182_39734"
            x="31"
            y="290"
            width="230"
            height="162"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="4" />
            <feGaussianBlur stdDeviation="10" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2182_39734"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2182_39734"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_2182_39734"
            x="345"
            y="230"
            width="230"
            height="162"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="4" />
            <feGaussianBlur stdDeviation="10" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2182_39734"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2182_39734"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_2182_39734"
            x="660"
            y="461"
            width="230"
            height="162"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="4" />
            <feGaussianBlur stdDeviation="10" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2182_39734"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2182_39734"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_d_2182_39734"
            x="975"
            y="219.108"
            width="230"
            height="162"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="4" />
            <feGaussianBlur stdDeviation="10" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2182_39734"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2182_39734"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  </InView>
</template>

<script>
import InView from '../../modules/InView.vue';

export default {
  name: 'MonthlyPremiumVsAge',

  components: {
    InView,
  },

  data() {
    return {
      // label: 'Play Timeline',
      isPlaying: false,
      status: {
        step1: false,
        step2: false,
        step3: false,
        step4: false,
      },
    };
  },

  computed: {
    hasPlayed() {
      return Object.values(this.status).every(Boolean);
    },
  },

  watch: {
    hasPlayed: {
      handler(newValue) {
        if (newValue) {
          this.label = 'Replay';
        }
      },
    },
  },

  methods: {
    toggleBox(step) {
      // Check if step exists in status object
      if (!(step in this.status)) return;

      this.status[step] = !this.status[step];
    },

    togglePlay() {
      if (!this.hasPlayed) {
        this.animateTimeline();
      } else {
        Object.keys(this.status).forEach((step) => {
          this.status[step] = false;
        });
        this.animateTimeline();
      }
    },

    animateTimeline() {
      Object.keys(this.status).forEach((step, index) => {
        setTimeout(() => {
          this.status[step] = true;
        }, index * 250);
      });
    },

    handleVisible() {
      this.animateTimeline();
    },
  },
};
</script>

<style scoped>
@keyframes bounce-in {
  0% {
    transform: rotate3d(1, 1, 1, 4deg);
    opacity: 0;
  }

  50% {
    transform: rotate3d(1, 1, 1, -4deg);
    opacity: 0.5;
  }

  100% {
    transform: rotate3d(1, 1, 1, 0deg);
    opacity: 1;
  }
}

.animate--bounce-in {
  animation-name: bounce-in;
  animation-duration: 500ms;
  animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
</style>
